module.exports = __webpack_public_path__ + "static/media/app03_ch01.2f2bd2a0.png";